module.exports = __webpack_public_path__ + "static/sport/mb-logo.3e64c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mb-logo.png
// module id = Mosb
// module chunks = 0